module.exports = __webpack_public_path__ + "media/01 profound.e8ed39aa.mp3";